// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditOrder_wrapper__P_bIf","noWrapper":"EditOrder_noWrapper__k_epN","overflow":"EditOrder_overflow__JCBpm","sideSheet":"EditOrder_sideSheet__RvY8c"};